import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "delivery-check-display",
  class DeliveryCheckDisplay extends WYATTElement {
    constructor() {
      super();

      this.availabilityResultsDefault = this.querySelector(
        "[data-availability-results='default']",
      );
      this.availabilityResultsAvailable = this.querySelector(
        "[data-availability-results='available']",
      );
      this.availabilityResultsUnavailable = this.querySelector(
        "[data-availability-results='unavailable']",
      );
      this.onSetup = this.setup.bind(this);
    }

    connectedCallback() {
      this.subscribe(WYATT.PubSub.events.storesFetched, this.onSetup);

      this.subscribe(WYATT.PubSub.events.userLocationChange, this.onSetup);
    }

    setup() {
      if (!WYATT.Geolocation.location.address) {
        return;
      }

      if (!WYATT.Geolocation.sortedStores) {
        return;
      }

      const isAvailable = WYATT.Geolocation.deliveryAvailable();

      this.availabilityResultsDefault.hidden = true;

      if (isAvailable) {
        this.availabilityResultsAvailable.hidden = false;
        this.availabilityResultsUnavailable.hidden = true;
      } else {
        this.availabilityResultsAvailable.hidden = true;
        this.availabilityResultsUnavailable.hidden = false;
      }
    }
  },
);
